import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { BookingsSumSheetRow as View } from './BookingsSumSheetRow'

import { fromCityTypeByLabelSelector } from 'reduxModules/selectors/CitySelectors'

const mapStateToProps = createStructuredSelector({
  fromCityTypeByLabel: fromCityTypeByLabelSelector,
})

export const BookingsSumSheetRow = connect(mapStateToProps)(View)


// WEBPACK FOOTER //
// ./src/components/BookingsSumSheet/components/BookingsSumSheetRow/index.js